<app-selector label="MTC" [data]="mtcCoreService.mtcList$| async" displayKey="name"
    [formControl]="ctrl" hintStyle="margin-left: -14px; margin-top: -5px" (refreshEvent)="refresh()" [loading]="mtcCoreService.loading" [hint]="hint">
</app-selector>
